import React from "react";
import PropTypes from "prop-types";
const SubscriptionListIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 19 17"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-3-2h24v24H-3z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"}>
        <path
          fillRule="nonzero"
          d="M3 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h12a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
        />
        <rect width="17" height="2" x="1" y="4" rx="1" />
        <g transform="matrix(-1 0 0 1 14 13)">
          <rect width="6" height="2" x="4" rx="1" />
          <circle cx="1" cy="1" r="1" />
        </g>
        <g transform="matrix(-1 0 0 1 14 9)">
          <rect width="6" height="2" x="4" rx="1" />
          <circle cx="1" cy="1" r="1" />
        </g>
      </g>
    </g>
  </svg>
);
SubscriptionListIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default SubscriptionListIcon;
